module.exports = __webpack_public_path__ + "static/media/calendar_icon_error.5cbf2cec.svg";